import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { HeroCmp, HeroProps } from "./Hero"
import { HeroFormCmp, HeroFormProps } from "./HeroForm"
import { HeroHighlightCmp, HeroHighlightProps } from "./HeroHighlight"
import { HeroFullBleedCmp, HeroFullBleedProps } from "./HeroFullBleed"
import { HeroFormAttrCmp, HeroFormAttrProps } from "./HeroFormAttr"

interface HeroWrapperBlokProps {
    blok: HeroProps & blokType
}
interface HeroFormWrapperBlokProps {
    blok: HeroFormProps & blokType
}
interface HeroHighlightWrapperBlokProps {
    blok: HeroHighlightProps & blokType
}
interface HeroFullBleedWrapperBlokProps {
    blok: HeroFullBleedProps & blokType
}
interface HeroFormAttrWrapperBlokProps {
    blok: HeroFormAttrProps & blokType
}

export const S22HeroNew: React.FC<HeroWrapperBlokProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <HeroCmp
            logo={blok.logo}
            logoUrl={blok.logoUrl}
            breadcrumbs={blok.breadcrumbs}
            program_logo={blok.program_logo}
            title={blok.title}
            description={blok.description}
            cta_button={blok.cta_button}
            image={blok.image}
            id={blok._uid}
            custom_id={blok.custom_id}
        />
    </SbEditable>
)

export const S22HeroForm: React.FC<HeroFormWrapperBlokProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <HeroFormCmp
            logo={blok.logo}
            logoUrl={blok.logoUrl}
            breadcrumbs={blok.breadcrumbs}
            program_logo={blok.program_logo}
            title={blok.title}
            description={blok.description}
            cta_button={blok.cta_button}
            image={blok.image}
            form_title={blok.form_title}
            form_copy={blok.form_copy}
            form={blok.form}
            dark_form={blok.dark_form}
            arrow={blok.arrow}
            attributes={blok.attributes}
            id={blok._uid}
            custom_id={blok.custom_id}
        />
    </SbEditable>
)

export const S22HeroHighlight: React.FC<HeroHighlightWrapperBlokProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <HeroHighlightCmp
            logo={blok.logo}
            logoUrl={blok.logoUrl}
            breadcrumbs={blok.breadcrumbs}
            program_logo={blok.program_logo}
            title={blok.title}
            description={blok.description}
            cta_button={blok.cta_button}
            image={blok.image}
            highlight={blok.highlight}
            id={blok._uid}
            custom_id={blok.custom_id}
        />
    </SbEditable>
)

export const S22HeroFullBleed: React.FC<HeroFullBleedWrapperBlokProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <HeroFullBleedCmp
            logo={blok.logo}
            logoUrl={blok.logoUrl}
            title={blok.title}
            description={blok.description}
            cta_button={blok.cta_button}
            image={blok.image}
            id={blok._uid}
            custom_id={blok.custom_id}
        />
    </SbEditable>
)

export const S22HeroFormAttr: React.FC<HeroFormAttrWrapperBlokProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <HeroFormAttrCmp
            title={blok.title}
            icon={blok.icon}
        />
    </SbEditable>
)

